import { render, staticRenderFns } from "./DisplayLabel.vue?vue&type=template&id=299e91b9&scoped=true"
import script from "./DisplayLabel.vue?vue&type=script&lang=js"
export * from "./DisplayLabel.vue?vue&type=script&lang=js"
import style0 from "./DisplayLabel.vue?vue&type=style&index=0&id=299e91b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299e91b9",
  null
  
)

export default component.exports